import { PropsWithChildren, ReactNode, forwardRef } from "react";
import { gridClasses, GridVariants } from "./Grid.style";

export type GridProps = GridVariants & {
  className?: string;
};

const Grid = forwardRef<HTMLDivElement, PropsWithChildren<GridProps>>(
  (props, ref) => {
    const {
      container,
      justifyContent,
      spacing,
      rowSpacing,
      columnSpacing,
      divideColumn,
      item,
      xs,
      sm,
      md,
      lg,
      className,
      ...rest
    } = props;

    return (
      <div
        {...rest}
        ref={ref}
        className={gridClasses({
          container,
          justifyContent,
          item,
          spacing,
          rowSpacing,
          columnSpacing,
          divideColumn,
          xs,
          sm,
          md,
          lg,
          class: className,
        })}
      />
    );
  }
);

export default Grid;
